import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch } from 'stores/Hooks'
import { setGlobalLoading } from 'stores/MovieSlice'

const NavigationLoader = () => {
  const location = useLocation()
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Show spinner when navigation starts
    dispatch(setGlobalLoading(true))

    // Hide spinner after a short delay to allow page to render
    const timer = setTimeout(() => {
      dispatch(setGlobalLoading(false))
    }, 300)

    return () => clearTimeout(timer)
  }, [location.pathname, dispatch])

  return null
}

export default NavigationLoader
